'use client';

import React from 'react';
import Link from 'next/link';
export default function TermsPage() {
  return (
    <main style={{ fontFamily: "'DM Sans', 'Roboto', sans-serif", minHeight: '100vh', background: '#f8fafc' }}>
      {/* Navbar */}
      <nav style={{ backgroundColor: '#fff', padding: '16px 0', boxShadow: '0 1px 4px rgba(0,0,0,0.08)' }}>
        <div style={{ maxWidth: '1100px', margin: '0 auto', padding: '0 40px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Link href="/" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center' }}>
            <img src="/assets/images/image-1778102925137.png" alt="HP Logo" width={91} height={61} style={{ objectFit: 'contain' }} />
          </Link>
          <Link href="/" style={{ color: 'rgb(49,107,156)', textDecoration: 'none', fontSize: '15px', fontWeight: 600 }}>← Back to Store</Link>
        </div>
      </nav>

      {/* Header */}
      <div style={{ background: 'linear-gradient(135deg, #003366 0%, #0d5fa3 100%)', padding: '48px 40px', textAlign: 'center' }}>
        <h1 style={{ color: '#fff', fontSize: '36px', fontWeight: 800, margin: '0 0 12px' }}>Terms of Service</h1>
        <p style={{ color: 'rgba(255,255,255,0.8)', fontSize: '16px', margin: 0 }}>Last updated: January 1, 2026</p>
      </div>

      {/* Content */}
      <div style={{ maxWidth: '860px', margin: '0 auto', padding: '48px 40px' }}>
        <div style={{ background: '#fff', borderRadius: '16px', padding: '48px', boxShadow: '0 2px 16px rgba(0,0,0,0.06)' }}>

          <section style={{ marginBottom: '36px' }}>
            <h2 style={{ fontSize: '22px', fontWeight: 700, color: '#003366', marginBottom: '14px' }}>1. Acceptance of Terms</h2>
            <p style={{ color: '#475569', lineHeight: 1.8, fontSize: '15px' }}>
              By accessing and using Barb Printer Store's website and services, you accept and agree to be bound by these Terms of Service and our Privacy Policy. If you do not agree to these terms, please do not use our services. These terms apply to all visitors, users, and others who access or use our service.
            </p>
          </section>

          <section style={{ marginBottom: '36px' }}>
            <h2 style={{ fontSize: '22px', fontWeight: 700, color: '#003366', marginBottom: '14px' }}>2. Description of Service</h2>
            <p style={{ color: '#475569', lineHeight: 1.8, fontSize: '15px' }}>
              Barb Printer Store provides an online marketplace for purchasing HP printers and related accessories. We also offer third-party technical support and printer setup assistance services. We are an independent third-party service provider and are not affiliated with, authorized by, or endorsed by HP Inc. or any other printer manufacturer.
            </p>
          </section>

          <section style={{ marginBottom: '36px' }}>
            <h2 style={{ fontSize: '22px', fontWeight: 700, color: '#003366', marginBottom: '14px' }}>3. Disclaimer of Affiliation</h2>
            <div style={{ background: '#fef3c7', border: '1px solid #fbbf24', borderRadius: '10px', padding: '16px 20px', marginBottom: '16px' }}>
              <p style={{ color: '#92400e', lineHeight: 1.8, fontSize: '15px', margin: 0, fontWeight: 600 }}>
                ⚠️ Important: We are NOT affiliated with HP Inc., Canon, Epson, Brother, or any other printer manufacturer. Any brand names or trademarks mentioned are used solely for descriptive and identification purposes.
              </p>
            </div>
            <p style={{ color: '#475569', lineHeight: 1.8, fontSize: '15px' }}>
              Our services are independent third-party technical assistance offerings. For official manufacturer support, please visit the respective manufacturer's official website.
            </p>
          </section>

          <section style={{ marginBottom: '36px' }}>
            <h2 style={{ fontSize: '22px', fontWeight: 700, color: '#003366', marginBottom: '14px' }}>4. User Accounts & Eligibility</h2>
            <ul style={{ color: '#475569', lineHeight: 1.8, fontSize: '15px', paddingLeft: '24px' }}>
              <li style={{ marginBottom: '8px' }}>You must be at least 18 years old to use our services</li>
              <li style={{ marginBottom: '8px' }}>You are responsible for maintaining the confidentiality of your account credentials</li>
              <li style={{ marginBottom: '8px' }}>You agree to provide accurate and complete information when creating an account</li>
              <li style={{ marginBottom: '8px' }}>You are responsible for all activities that occur under your account</li>
            </ul>
          </section>

          <section style={{ marginBottom: '36px' }}>
            <h2 style={{ fontSize: '22px', fontWeight: 700, color: '#003366', marginBottom: '14px' }}>5. Products & Pricing</h2>
            <p style={{ color: '#475569', lineHeight: 1.8, fontSize: '15px' }}>
              All prices are listed in US Dollars and are subject to change without notice. We reserve the right to modify or discontinue any product at any time. We are not responsible for typographical errors in pricing. In the event of a pricing error, we reserve the right to cancel orders placed at the incorrect price.
            </p>
          </section>

          <section style={{ marginBottom: '36px' }}>
            <h2 style={{ fontSize: '22px', fontWeight: 700, color: '#003366', marginBottom: '14px' }}>6. Orders & Payment</h2>
            <p style={{ color: '#475569', lineHeight: 1.8, fontSize: '15px' }}>
              By placing an order, you represent that you are authorized to use the payment method provided. All orders are subject to acceptance and availability. We reserve the right to refuse or cancel any order for any reason, including but not limited to product availability, errors in product or pricing information, or suspected fraud.
            </p>
          </section>

          <section style={{ marginBottom: '36px' }}>
            <h2 style={{ fontSize: '22px', fontWeight: 700, color: '#003366', marginBottom: '14px' }}>7. Shipping & Delivery</h2>
            <p style={{ color: '#475569', lineHeight: 1.8, fontSize: '15px' }}>
              Shipping times are estimates and not guaranteed. We are not responsible for delays caused by carriers, customs, or other factors outside our control. Risk of loss and title for items purchased pass to you upon delivery to the carrier.
            </p>
          </section>

          <section style={{ marginBottom: '36px' }}>
            <h2 style={{ fontSize: '22px', fontWeight: 700, color: '#003366', marginBottom: '14px' }}>8. Intellectual Property</h2>
            <p style={{ color: '#475569', lineHeight: 1.8, fontSize: '15px' }}>
              The content on this website, including text, graphics, logos, and images, is the property of Barb Printer Store and is protected by applicable intellectual property laws. You may not reproduce, distribute, or create derivative works without our express written permission.
            </p>
          </section>

          <section style={{ marginBottom: '36px' }}>
            <h2 style={{ fontSize: '22px', fontWeight: 700, color: '#003366', marginBottom: '14px' }}>9. Limitation of Liability</h2>
            <p style={{ color: '#475569', lineHeight: 1.8, fontSize: '15px' }}>
              To the maximum extent permitted by law, Barb Printer Store shall not be liable for any indirect, incidental, special, consequential, or punitive damages, including but not limited to loss of profits, data, or goodwill, arising out of or in connection with your use of our services. Our total liability shall not exceed the amount paid by you for the specific product or service giving rise to the claim.
            </p>
          </section>

          <section style={{ marginBottom: '36px' }}>
            <h2 style={{ fontSize: '22px', fontWeight: 700, color: '#003366', marginBottom: '14px' }}>10. Governing Law</h2>
            <p style={{ color: '#475569', lineHeight: 1.8, fontSize: '15px' }}>
              These Terms shall be governed by and construed in accordance with the laws of the United States, without regard to its conflict of law provisions. Any disputes arising under these terms shall be subject to the exclusive jurisdiction of the courts located in the United States.
            </p>
          </section>

          <section>
            <h2 style={{ fontSize: '22px', fontWeight: 700, color: '#003366', marginBottom: '14px' }}>11. Contact Us</h2>
            <p style={{ color: '#475569', lineHeight: 1.8, fontSize: '15px' }}>
              For questions about these Terms of Service, please contact us:<br />
              <strong>Email:</strong> <a href="mailto:legal@barbprinterstore.online" style={{ color: 'rgb(49,107,156)' }}>legal@barbprinterstore.online</a><br />
              <strong>Website:</strong> <a href="/" style={{ color: 'rgb(49,107,156)' }}>barbprinterstore.online</a>
            </p>
          </section>
        </div>
      </div>

      {/* Footer */}
      <footer style={{ background: '#1e293b', padding: '32px 40px', marginTop: '40px' }}>
        <div style={{ maxWidth: '1100px', margin: '0 auto', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '16px' }}>
          <span style={{ color: '#94a3b8', fontSize: '14px' }}>© 2026 Barb Printer Store. All Rights Reserved.</span>
          <div style={{ display: 'flex', gap: '24px', flexWrap: 'wrap' }}>
            <Link href="/privacy-policy" style={{ color: '#94a3b8', textDecoration: 'none', fontSize: '14px' }}>Privacy Policy</Link>
            <Link href="/terms-and-condition" style={{ color: '#7dd3fc', textDecoration: 'none', fontSize: '14px' }}>Terms of Service</Link>
            <Link href="/refund-policy" style={{ color: '#94a3b8', textDecoration: 'none', fontSize: '14px' }}>Refund Policy</Link>
            <Link href="/contact-us" style={{ color: '#94a3b8', textDecoration: 'none', fontSize: '14px' }}>Contact</Link>
          </div>
        </div>
      </footer>
    </main>
  );
}
